<div class="multi-field">
  @for (entry of entryFields; track $index; let i = $index) {
  <div class="multi-field__row">
    <field [field]="entry" (onFieldUpdate)="onChildUpdated()"></field>
    <div class="multi-field__actions">
      <button
        type="button"
        class="btn-icon"
        aria-label="Add option"
        (click)="addOption(i)"
        [disabled]="max !== null && entryFields.length >= max"
        title="Add"
      >
        +
      </button>
      <button
        type="button"
        class="btn-icon"
        aria-label="Remove option"
        (click)="removeOption(i)"
        [disabled]="entryFields.length <= min"
        title="Remove"
      >
        −
      </button>
    </div>
  </div>
  } @if (entryFields.length === 0) {
  <div class="multi-field__addline">
    <button
      type="button"
      class="btn-icon"
      aria-label="Add option"
      (click)="addOption()"
      [disabled]="max !== null && entryFields.length >= max"
    >
      +
    </button>
  </div>
  }
</div>
